// extracted by mini-css-extract-plugin
export default {"personIcon":"list_personIcon__O+s+-","users":"list_users__x9Xos","user":"list_user__5-G4S","username":"list_username__LlJDh"};